import request from '../utils/request.js'
import qs from 'qs'
import router from '@/router/index.js'
import { Message, Loading } from 'element-ui'

//未登录函数复用
function CheckToken(res) {
    if (res.data.code == -1001 || res.data.code == -1002) {
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('userInfo')
        Message.closeAll()
        Message({
            type: 'warning',
            message: '登录失效，请重新登录',
            duration: 1500,
        })
        router.push('/login')
    } else if (res.data.code != 200) {
        Message({
            type: 'warning',
            message: res.data.msg,
            duration: 1500
        })
    }
}

//用户绑定
function UserBinding(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在提交",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.post('/api/WangtingBd/BdUser', data).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

//获取绑定用户列表
function GetBindList() {
    return new Promise((resolve, reject) => {
        request.get('/api/WangtingBd/bdUserList').then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

//解除用户绑定
function RelieveBind(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在提交",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.post('/api/WangtingBd/UnBdUser', data).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

// 业务办理查询获取列表
function SearchBusiness(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/Query/progress?' + qs.stringify(data)).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

// 水费查询
function SearchWater(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/Query/balance?' + qs.stringify(data)).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

// 历史账单查询
function SearchHistory(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/Query/GetOldWaterBill?' + qs.stringify(data)).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

// 缴费记录查询
function SearchRecord(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/Query/GetPayRecord?' + qs.stringify(data)).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

// 获取电子发票列表
function GetInvoiceList(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/EInvoice/GetEInvoiceRecord?' + qs.stringify(data)).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

// 发票开具
function HandleInvoice(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/EInvoice/CreateEInvoice?' + qs.stringify(data)).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

// 发票查看
function WatchInvoice(data) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/EInvoice/ViewEInvoice?' + qs.stringify(data)).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

export { UserBinding, GetBindList, RelieveBind, SearchBusiness, SearchWater, SearchHistory, SearchRecord, GetInvoiceList, HandleInvoice, WatchInvoice }